import {
    SprayApplicationRate,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectEquipmentSetField } from 'services/equipmentSets/selectors';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import { OwnProps } from './index';
import { HECTARE } from '../../../ProductRatePerUnitTypeDropdown/constants';

const selectUnits = (state: AppState, props: OwnProps): number =>
    (props.product && props.product.units) || 0;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): SprayProductPerUnitType =>
    (props.product && props.product.perUnitType) || HECTARE;

const selectApplicationRate = (
    state: AppState,
    props: OwnProps
): SprayApplicationRate => props.applicationRate;

const selectRatePerTank = createDeepEqualSelector(
    selectUnits,
    selectApplicationRate,
    selectPerUnitType,
    makeSelectEquipmentSetField('tankVolume'),
    makeSelectUnitTypeFieldValue('name'),
    (units, applicationRate, perUnitType, tankVolume: number, unitTypeName) => {
        const unitType = unitTypeName || '';
        const unitsPerArea =
            perUnitType === HECTARE ? units : (units * applicationRate) / 100;
        const unitsPer100L = (unitsPerArea * 100) / applicationRate;

        return `${Number((tankVolume * unitsPer100L) / 100).toFixed(
            2
        )} ${unitType}`;
    }
);

const makeSelectRatePerTank = (): typeof selectRatePerTank => selectRatePerTank;

export { makeSelectRatePerTank };
